import { render } from "./flag-list.vue?vue&type=template&id=b9a99fe2&scoped=true"
import script from "./flag-list.vue?vue&type=script&lang=js"
export * from "./flag-list.vue?vue&type=script&lang=js"

import "./flag-list.vue?vue&type=style&index=0&id=b9a99fe2&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a99fe2"]])

export default __exports__